import React, { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Sparkles, ArrowLeft } from "lucide-react";
import { PromptTool } from "@/components/PromptTool";
import { UsagePanel } from "@/components/UsagePanel";
import { BuyButton } from "@/components/BuyButton";

export default function ToolPage() {
  const [params] = useSearchParams();
  const categoria = params.get("categoria");
  const [userState, setUserState] = useState(null);

  return (
    <main className="min-h-screen px-4 pb-20 pt-24 sm:px-6">
      <div className="mx-auto max-w-3xl">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm font-medium text-slate-400 hover:text-white no-underline"
        >
          <ArrowLeft className="h-4 w-4" /> Voltar à página inicial
        </Link>

        <div className="mt-6 text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-violet-500/30 bg-violet-500/10 px-4 py-1.5 text-sm font-semibold text-violet-300">
            <Sparkles className="h-4 w-4" /> Ferramenta Pronto.AI
          </span>
          <h1 className="mt-5 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
            Gere sua instrução pronta para usar
          </h1>
          <p className="mx-auto mt-3 max-w-md text-sm text-slate-400">
            Escolha uma categoria, responda algumas perguntas e copie o resultado.
          </p>
        </div>

        <div className="mt-8">
          <UsagePanel userState={userState} />
        </div>

        <div className="mt-6">
          <PromptTool
            initialCategoryId={categoria}
            enforceCredits={true}
            onUserState={setUserState}
          />
        </div>

        {!userState?.is_paid && (
          <div className="mt-12 glass rounded-3xl p-6 text-center">
            <p className="text-sm text-slate-300">
              Gostou? Garanta o acesso completo por apenas <span className="font-bold text-white">R$ 4,99</span> por 1 ano.
            </p>
            <div className="mt-5 flex justify-center">
              <BuyButton label="QUERO ACESSAR POR R$ 4,99" source="ferramenta" testId="tool-page-cta" />
            </div>
          </div>
        )}
      </div>
    </main>
  );
}
